import React from "react";
import styled from "styled-components";

import { Fonts } from "assets/fonts";

import { Separator } from "../styled-data";

const TableWrapper = styled.div`
  position: relative;
  z-index: 0;
  max-height: 100%;
  overflow: auto;
  padding: 0 32px 16px 32px;
  margin: 0 -32px;
  background-color: inherit;

  & + & {
    margin-top: 24px;
  }
`;

const StyledTable = styled.table`
  position: relative;
  z-index: 0;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  background-color: inherit;
  ${Fonts.regular_14}
`;

const TableHeader = styled.thead<{ $hasGrouping: boolean }>`
  width: 100%;
  height: 36px;
  background-color: inherit;

  tr {
    background-color: inherit;
  }
  th {
    top: ${(p) => (p.$hasGrouping ? "28px" : "0")};
  }
`;

const Title = styled.h4`
  padding: 0 16px;
  ${Fonts.semiBold_16};
`;

const TableBody = styled.tbody`
  width: 100%;
  padding: 0;
  border-radius: 4px;
  overflow: hidden;

  tr:nth-of-type(2) td:first-of-type {
    border-top-left-radius: 4px;
  }
  tr:nth-of-type(2) td:last-of-type {
    border-top-right-radius: 4px;
  }
  tr:last-of-type td:first-of-type {
    border-bottom-left-radius: 4px;
  }
  tr:last-of-type td:last-of-type {
    border-bottom-right-radius: 4px;
  }
`;

const Space = styled.tr`
  height: 16px;
  background-color: transparent;
`;

interface TableProps {
  className?: string;
  displayTitle?: boolean;
  title: string;
  renderColGroups?: () => React.ReactNode;
  renderColGroupTitles?: () => React.ReactNode;
  renderColumnTitles: () => React.ReactNode;
  renderItems: () => React.ReactNode;
}
export const Table = (props: TableProps) => {
  const {
    className,
    displayTitle,
    title,
    renderColGroups,
    renderColGroupTitles,
    renderColumnTitles,
    renderItems,
  } = props;
  return (
    <TableWrapper className={className}>
      {displayTitle && (
        <>
          <Title>{title}</Title>
          <Separator />
        </>
      )}
      {renderColGroupTitles && renderColGroupTitles()}
      <StyledTable title={title}>
        {renderColGroups && renderColGroups()}
        <TableHeader
          data-testid="Table_header"
          className={className ? `${className}-header` : ""}
          $hasGrouping={!!renderColGroupTitles}
        >
          <tr>{renderColumnTitles()}</tr>
        </TableHeader>
        <TableBody data-testid="Table_body">
          <Space aria-hidden={true} className={className ? `${className}-space` : ""} />
          {renderItems()}
        </TableBody>
      </StyledTable>
    </TableWrapper>
  );
};
